import { render, staticRenderFns } from "./resignation.vue?vue&type=template&id=6a542c49&scoped=true"
import script from "./resignation.vue?vue&type=script&lang=js"
export * from "./resignation.vue?vue&type=script&lang=js"
import style0 from "./resignation.vue?vue&type=style&index=0&id=6a542c49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a542c49",
  null
  
)

export default component.exports